// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22KPc","placeholdersHeader":"styles_placeholdersHeader__2-HeO","editorStyle":"styles_editorStyle__9di5B","placeholdersBox":"styles_placeholdersBox__3jRx6"};